import script from "./returnTable.vue?vue&type=script&setup=true&lang=js"
export * from "./returnTable.vue?vue&type=script&setup=true&lang=js"

import "./returnTable.vue?vue&type=style&index=0&id=177f9bb0&lang=less"

const __exports__ = script;

export default __exports__